import React, { useState, useEffect, useRef } from "react";
import SectionHeader from "../../components/SectionHeader";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { MdCheck } from "react-icons/md";
import "./contact.scss";

export const Contact = () => {
  const [isBtnClicked, setIsBtnClicked] = useState(false);
  const [isBackBtnClicked, setIsBackBtnClicked] = useState(false);
  const [formData, setFormData] = useState({});
  const [data, setData] = useState({
    userName: "",
    userEmail: "",
    userMessage: "",
  });

  const formRef = useRef(null);
  const progressBarRef = useRef(null);
  const progressRef = useRef(null);
  const successMsgRef = useRef(null);
  const backBtnRef = useRef(null);

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    const tl = gsap.timeline();

    isBtnClicked &&
      tl
        .to(formRef.current, {
          duration: 0.5,
          y: "100%",
          opacity: 0,
          ease: "back.out",
        })
        .to(
          progressBarRef.current,
          {
            duration: 0.5,
            y: "-100%",
            opacity: 1,
            ease: "power3.out",
          },
          "-=0.5"
        )
        .to(progressRef.current, {
          duration: 3,
          width: "100%",
          ease: "power3.out",
        })
        .to(successMsgRef.current, {
          duration: 0.5,
          y: "-200%",
          opacity: 1,
          ease: "power3.out",
          onComplete: () => {
            setIsBtnClicked(false);
          },
        });

    if (isBackBtnClicked) {
      tl.to(successMsgRef.current, {
        duration: 0.5,
        y: "-90%",
        opacity: 0,
        ease: "back.out",
      })
        .to(
          progressRef.current,
          {
            duration: 0,
            width: "0%",
            ease: "none",
          },
          "-=0.5"
        )
        .to(
          progressBarRef.current,
          {
            duration: 0,
            y: "-200%",
            opacity: 0,
            ease: "none",
          },
          "-=0.5"
        )
        .to(
          formRef.current,
          {
            duration: 0.5,
            y: "0%",
            opacity: 1,
            ease: "power3.out",
            onComplete: () => {
              setIsBackBtnClicked(false);
            },
          },
          "-=0.5"
        );
    }

    return () => {
      tl.kill();
    };
  }, [isBtnClicked, isBackBtnClicked]);

  function onNameChange(e) {
    setData({ ...data, userName: e.target.value });
  }
  function onEmailChange(e) {
    setData({ ...data, userEmail: e.target.value });
  }
  function onMessageChange(e) {
    setData({ ...data, userMessage: e.target.value });
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsBtnClicked(true);

    console.log(data);
    fetch("http://localhost:7000/contact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setFormData(data);
      })
      .catch((err) => {
        console.log(err);
      });

    setData({
      userName: "",
      userEmail: "",
      userMessage: "",
    });
  };
  // console.log(formData);

  const subtitle = "Have an idea or a project you wanna to build? ";
  const paragraph =
    "feel free to get in touch with me, i am always excited to connect with new people and build cool and useful things together.";
  return (
    <section className="contact section" id="contact">
      <div className="section-wrapper">
        <SectionHeader title="Contact." subtitle={subtitle} p={paragraph} />
        <div className="contact-body content">
          <div className="contact-form">
            <form
              ref={formRef}
              method="POST"
              className="form"
              id="contact-form"
              onSubmit={handleSubmit}
            >
              <input
                placeholder="Name"
                type="text"
                name="name"
                required
                value={data.userName}
                onChange={onNameChange}
              />
              <input
                placeholder="Enter email"
                type="email"
                name="email"
                required
                value={data.userEmail}
                onChange={onEmailChange}
              />
              <textarea
                placeholder="Your Message"
                type="text"
                name="message"
                required
                value={data.userMessage}
                onChange={onMessageChange}
              ></textarea>
              <button
                className="submit-btn btn"
                type="submit"
                id="submit"
                disabled={
                  !data.userName || !data.userEmail || !data.userMessage
                }
              >
                {" "}
                Submit{" "}
              </button>
            </form>
            <div ref={progressBarRef} className="progress-container">
              <div className="progress-wrapper">
                <h3>your message is sending...</h3>
                <div className="progress-bar">
                  <div ref={progressRef} className="progress-bar-fill"></div>
                </div>
              </div>
            </div>
            <div ref={successMsgRef} className="success-container">
              <div className="success-wrapper">
                <MdCheck fontSize={60} />
                <h3>{formData.message}</h3>
                <button
                  ref={backBtnRef}
                  onClick={() => setIsBackBtnClicked(true)}
                  className="btn btn-back"
                >
                  Back
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
